import { withInstall } from '@pc-fx-framework/utils/with-install'
import PageDetail from './src/page-detail.vue'

export const FxPageDetail = withInstall(PageDetail)
export default FxPageDetail

export * from './src/types'
